<template>
  <v-menu v-model="dialog.open" right
    :close-on-content-click="false">
  <v-list-tile  slot="activator" class="hover-pointer">
    <v-list-tile-action class="pr-1 pl-2 mr-1">
      <v-icon title="Recommend a friend"  light>group</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>Recommend a friend</v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
      <v-card>
        <v-card-title>
          <span class="headline">{{title}}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
                ></v-text-field>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-spacer></v-spacer> -->
          <v-btn color="primary" outline round @click.native="dialog.open = false">Close</v-btn>
          <v-btn color="primary" round @click="submit" :loading="loading" :disabled="loading">submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  <!-- <v-btn flat color="primary" @click.native="dialog.open = true"><v-icon left>group</v-icon> Recommended a friend</v-btn> -->
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  data () {
    return {
      dialog: {
        open: false
      },
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  computed: {
    title () {
      return 'Recommend to Friend'
    },
    ...mapState('user', {
      loading: 'loading'
    })
  },
  methods: {
    cb () {
      this.$refs.form.reset()
      this.dialog.open = false
    },
    submit () {
      if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
        Store.dispatch('user/recommendToFriend', {email: this.email, cb: this.cb})
        // this.dialog.open = false
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>
<style>
.hover-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/RecommendToFriendTile.vue